"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("../utils/redux");
const remoting_1 = require("../constants/remoting");
const get_1 = __importDefault(require("lodash/get"));
exports.initialState = {
    iceConnectionState: undefined,
    receiving: false,
    sending: false,
    stream: null
};
exports.default = redux_1.createReducer(exports.initialState, {
    [remoting_1.actions.WIRELESS_PRESENTATION_ICE_STATE_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { iceConnectionState: get_1.default(action, 'payload') });
    },
    [remoting_1.actions.WIRELESS_PRESENTATION_ON_STREAM]: (state, action) => {
        return Object.assign(Object.assign({}, state), { receiving: true, stream: action.payload });
    },
    [remoting_1.actions.WIRELESS_PRESENTATION_STREAM_ENDED]: state => {
        return Object.assign(Object.assign({}, state), { receiving: false, stream: null });
    },
    [remoting_1.actions.WIRELESS_PRESENTATION_SEND_START]: state => {
        return Object.assign(Object.assign({}, state), { sending: true });
    },
    [remoting_1.actions.WIRELESS_PRESENTATION_SEND_END]: state => {
        return Object.assign(Object.assign({}, state), { sending: false });
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/clients.remoting/dist/reducers/wireless-presentation.js
// module id = 606
// module chunks = 0